import React from 'react'
import Table from '../../common/Table'
import TextInput from '../../common/TextInput'
import ModalBasic from '../../../pages/component/ModalBasic'

function MaterialListModelForQc(props) {
    return (
        <ModalBasic
            id="material-list-qc"
            modalOpen={props.setGrnMaterialDetailspopUp}
            setModalOpen={() => props.setOpenModel()}
            title="Material List"
            className="p-5 !w-[70%]"
        >
            {/* {props.sampleEntryType !== 'FinishProducts' ?
                <div className="itemList-field mb-2.5">
                    <div className='input-grp max-w-[320px] w-full'>
                        <TextInput
                            className="inputFocus"
                            type="text"
                            id="grnNo"
                            name="grnNo"
                            value={props.sampleObject.grnNo}
                            onChange={(event) => props.handleChange(event, "grnNo")}
                            disabled
                        />
                    </div>
                </div>
                : null} */}
            <div className='list-tabel'>
                <Table
                    tableData={props.tableData}
                    columns={props.columns}
                    scrollHeight="calc(100dvh - 190px)"
                />
            </div>
        </ModalBasic>
    )
}

export default MaterialListModelForQc
